export const localization = {
  en: {
    wellnessResources: 'More from CHOC',
    resource1_title: 'Parenting Content',
    resource2_title: 'CHOC News',
    resource3_title: 'Visiting CHOC',
    resource4_title: 'Patients & Families',
    resource5_title: 'Ways to Help',
    resource6_title: 'Stay Connected',
    links_area_title: 'More from CHOC',
    read: ' Read > '
  },
  es: {
    wellnessResources: 'Más de CHOC',
    resource1_title: 'Contenido para Padres',
    resource2_title: 'Noticias CHOC',
    resource3_title: 'Visitando CHOC',
    resource4_title: 'Pacientes y Familiares',
    resource5_title: 'Maneras de Ayudar',
    resource6_title: 'Mantenerse Conectado',
    links_area_title: 'Más de CHOC',
    read: ' Leer > '
  },
  keyMapping: {
    wellnessResources: 'Más de CHOC',
    resource1_title: 'UFD_More_From_CHOC_01',
    resource2_title: 'UFD_More_From_CHOC_02',
    resource3_title: 'UFD_More_From_CHOC_03',
    resource4_title: 'UFD_More_From_CHOC_04',
    resource5_title: 'UFD_More_From_CHOC_05',
    resource6_title: 'UFD_More_From_CHOC_06',
    links_area_title: 'UFD_More_From_CHOC_Text',
    read: 'UFD_Read_Button'
  }
}
